export default {
	BASE_STORAGE: process.env.REACT_APP_BASE_STORAGE,
	BASE_API: process.env.REACT_APP_BASE_API,
	BASE_PUBLIC: process.env.REACT_APP_BASE_PUBLIC,
	TIMEZONE: 'America/Caracas',
	LEVELS: {
		ADMIN: 1,
		MODERATOR: 2,
		CLIENT: 3
	},
	USER: {
		VERIFIED: {
			PENDING: 0,
			APPROVED: 1,
			REJECTED: 2,
		},
		STATUS: {
			PENDING: 0,
			ACTIVE: 1,
			INACTIVE: 2,
		}
	},
	MODULES: {
		HOME: 1,
		USERS: 2,
		PLANS: 3,
		PAYMENTS: 4,
		NEWS: 5,
		INCOMES: 6,
		MONEY: 7,
		CHAT: 8,
    	CHAT_INFORMATION: 9
	},
	PLANS: {
	    FREE: 1,
	    PREMIUM: 2
	},
	CATEGORY_TYPES: {
	    INCOMES: 1,
	    EXPENSES: 2,
	    DEBTS: 3
	},
	MONEY_CATEGORIES: {
		REAL_STATE: 1,
		CARS: 2,
		JEWELRY: 3,
		ART: 4,
		STOCKS: 5,
		CRYPTO: 6,
		BONDS: 7,
		BANK: 8,
		EXCHANGE: 9,
		CASH: 10
	},
}